<template>
  <div class="unit-items">
    <div class="unit-title">
      <span class="small black--text font-weight-bold text-uppercase">{{
        subtitle
      }}</span>
      <h3 class="font-weight-regular mb-0 black--text title">
        {{ title }}
      </h3>
    </div>
    <draggable
      class="inner mt-5"
      :list="items"
      group="order"
      @start="startDrag()"
      @end="endDrag()"
      :ref="name"
      :id="name"
    >
      <div
        v-for="(item, index) in items"
        :key="`unit-${index}`"
        class="item"
        :data-id="`${Math.round(new Date().getTime() / 1000)}`"
      >
        <v-textarea
          color="amber"
          v-model="item.title"
          :rows="1"
          :autoGrow="true"
          v-if="editMode"
          :hide-details="true"
        />
        <p v-else>
          <span class="font-weight-bold">{{ item.title }}</span
          ><br /><span v-if="item.description">{{ item.description }}</span>
        </p>
      </div>
    </draggable>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
export default {
  name: "AreaItems",
  data() {
    return {
      items: this.value,
      item: {},
      currIndex: null,
      refs: null,
      fields: [],
      editMode: false,
      editIndex: "",
    };
  },
  props: {
    value: Array,
    name: String,
    title: String,
    subtitle: String,
  },
  components: {
    draggable,
  },
  watch: {
    value: {
      handler: function(val) {
        this.items = val;
      },
      deep: true,
    },
  },
  mounted() {
    if (this.collection) {
      this.getRefs();
    }
  },
  methods: {
    add() {
      let item = {
        index: this.items.length,
        title: this.item.title,
        id: this.items.length,
        type: "content",
      };
      this.items.push(item);
      this.item = {};

      this.editMode = false;
      this.currId = null;
      this.currIndex = null;
    },
    remove(index) {
      this.items.splice(index, 1);
    },
    edit(index) {
      this.editMode = !this.editMode;
      this.editIndex = index;
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      div.children.forEach((doc) => {
        let item = this.items.find((x) => x.id == doc.dataset.id);
        if (item) {
          let indexOfItem = this.items.indexOf(item);
          item.index = count;
          vm.$set(vm.items, indexOfItem, item);
        }
        count++;
      });
      this.dragging = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.unit-items {
  min-height: 30vh;
  .item {
    padding: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0.5rem 0;
    border-radius: 5px;
    color: black;
    background: rgb(255, 255, 255, 0.9);
    .icons {
      width: 50px;
      padding: 0 10px;
      display: flex;
    }
  }
}
.unit-title {
  padding-bottom: 0px;
}
.add-button {
  margin: 0 !important;
  position: relative;
  right: 0;
}
.unit-field {
  margin: 0.75rem 0 !important;
}
</style>
